var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"toast",staticClass:"toast",attrs:{"id":"toast"}},[_c('div',{ref:"toastMessage",staticClass:"toast-message"})])
}
var staticRenderFns = []

export { render, staticRenderFns }